import { useMutation, useQuery } from '@tanstack/react-query';
import { api, type ApiError, type ListSmsResult } from '@whinerp/client';
import { Panel, SectionLabel } from '@whinerp/ui';
import { useErrorMessage, useT } from '../../app/i18n.js';

/** The SMS template an SMS campaign sends (F-070). */
export function CampaignSmsTemplate({ campaignId, editable }: { campaignId: string; editable: boolean }): JSX.Element {
  const t = useT();
  const errorText = useErrorMessage();
  const data = useQuery<ListSmsResult, ApiError>({ queryKey: ['sms'], queryFn: () => api.listSms({}) });
  const choose = useMutation({ mutationFn: (templateId: string | null) => api.setCampaignSmsTemplate({ path: { campaignId }, body: { templateId } }) });
  return (
    <Panel data-region="campaign-sms-template">
      <div className="flex flex-col gap-1">
        <SectionLabel>{t('sms.campaignTemplate')}</SectionLabel>
        <select
          data-campaign-sms-template
          aria-label={t('sms.campaignTemplate')}
          disabled={!editable}
          defaultValue=""
          onChange={(e) => choose.mutate(e.target.value || null)}
          className="h-input rounded-control border border-control bg-surface px-3 text-body text-ink"
        >
          <option value="">{t('sms.chooseTemplate')}</option>
          {(data.data?.templates ?? []).map((template) => (
            <option key={template.templateId} value={template.templateId}>{template.name}</option>
          ))}
        </select>
        {choose.error ? <p className="text-dense text-danger-text">{errorText(choose.error)}</p> : null}
      </div>
    </Panel>
  );
}
